import React from 'react';
import PropTypes from 'prop-types';
import MFaq from '../molecules/_molecules.faq';

export default class OFaq extends React.Component {
	constructor(props) {
		super(props);

		this.state = { openRow: undefined };
	}

	handleRowToggle({ question, isOpen }) {
		this.setState({
			openRow: isOpen ? question : undefined,
		});
	}

	render() {
		return (
			<article className={`o-faq ${this.props.className}`}>
				<header className="o-faq--header">
					<h2>{this.props.title}</h2>
				</header>
				{
					this.props.items.map((faq) => {
						return (
							<MFaq
								key={faq.uuid}
								question={faq.title}
								answer={faq.description}
								onClick={isOpen => this.handleRowToggle({ question: faq.uuid, isOpen })}
								isOpen={this.state.openRow === faq.uuid}
							/>
						);
					})
				}
			</article>
		);
	}
}

OFaq.propTypes = {
	title: PropTypes.string,
	className: PropTypes.string,
	items: PropTypes.array,
};

OFaq.defaultProps = {
	title: '',
	className: '',
	items: [],
};



// WEBPACK FOOTER //
// ./src/components/organisme/_organisme.faq.js